/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Ruoli degli utenti. Ruoli previsti:   -*ADMIN*  -*OP_COMUNE*  -*OP_SCUOLA*  -*OP_CENTRO_COTTURA*  -*GENITORE*  -*CITTADINO*
 */
export type AuthorityType = 'ADMIN' | 'OP_COMUNE' | 'OP_SCUOLA' | 'OP_CENTRO_COTTURA' | 'GENITORE' | 'CITTADINO';

export const AuthorityType = {
    ADMIN: 'ADMIN' as AuthorityType,
    OPCOMUNE: 'OP_COMUNE' as AuthorityType,
    OPSCUOLA: 'OP_SCUOLA' as AuthorityType,
    OPCENTROCOTTURA: 'OP_CENTRO_COTTURA' as AuthorityType,
    GENITORE: 'GENITORE' as AuthorityType,
    CITTADINO: 'CITTADINO' as AuthorityType
};